module.exports = __webpack_public_path__ + "static/sparrow-c93db1a288ea09966f03a78df5e2a1da.jpg";